module.exports = __webpack_public_path__ + "img/symbol_12.6f4a8d84.png";